import { Component, Input, OnInit, ViewChild } from '@angular/core'
import * as lodash from 'lodash'
import { DataEntityType, ConfirmDialogService, dataEntityTypes } from '@tokeet-frontend/tv3-platform'
import { GetEntityTags, RemoveTagFromAllEntities, selectEntityTags, selectEntityTypeTags } from '@tokeet-frontend/tags'
import { select, Store } from '@ngrx/store'
import { map } from 'rxjs/operators'
import { combineLatest, Observable } from 'rxjs'
import { EntityFormTagsComponent } from '../entity-form-tags/entity-form-tags.component'

export type ManageEntityTagsOnSubmit = (tags: string[]) => unknown

@Component({
  selector: 'app-manage-entity-tags',
  templateUrl: './manage-entity-tags.component.html',
  styleUrls: ['./manage-entity-tags.component.scss'],
})
export class ManageEntityTagsComponent implements OnInit {
  @ViewChild(EntityFormTagsComponent) tagsField?: EntityFormTagsComponent

  @Input() type: DataEntityType
  @Input() id: string
  @Input() showSuggesttedTags = true
  @Input() tags: string[] = []
  @Input() tagsFieldLabel = $localize`Tags`
  @Input() autoSave = true
  @Input() showModifiedMsg = true
  @Input() onSubmit: ManageEntityTagsOnSubmit | null = null

  tags$: Observable<string[]>

  constructor(private store: Store<any>, private confirm: ConfirmDialogService) {}

  ngOnInit() {
    if (this.id && this.type) {
      this.store.dispatch(GetEntityTags({ entityType: this.type, entityId: this.id }))
    }
    this.tags$ = combineLatest([
      this.store.pipe(select(selectEntityTags(this.type, this.id))),
      this.store.pipe(select(selectEntityTypeTags(this.type))),
    ]).pipe(map(([entityTags, tags]) => lodash.difference(tags, entityTags)))
  }

  // TV4-6241: Confirm then remove the tag from every entity of this type
  // (works for any DataEntityType: rental, guest, inquiry, task, invoice, etc).
  onRemoveSuggestedTag(tag: string) {
    const label = dataEntityTypes.find((t) => t.value === this.type)?.label || this.type
    this.confirm
      .confirm({
        title: $localize`Remove tag`,
        body: $localize`Remove "${tag}" from all ${label} records? This cannot be undone.`,
        isDangerous: true,
      })
      .subscribe(() => {
        this.store.dispatch(RemoveTagFromAllEntities({ entityType: this.type, tag }))
        // Also strip it from the open form's draft value. Otherwise a
        // Save right after removal (with the tag still in the unsaved draft)
        // would silently re-add the tag we just deleted account-wide.
        this.tagsField?.remove(tag)
      })
  }

  save() {
    if (this.onSubmit && this.tagsField) {
      const result = this.onSubmit(this.tagsField.getTags())
      if (result !== true) return
    }

    this.tagsField?.save()
  }
}
